(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
    function initStudentFields(sectionId) {
      var container = document.getElementById('StudentFields-' + sectionId);
      if (!container) return;
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      var form = container.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      var nameInput = document.getElementById('StudentName-' + sectionId);
      var classInput = document.getElementById('StudentClass-' + sectionId);

      function isValid() {
        return nameInput.value.trim().length > 0 && classInput.value.trim().length > 0;
      }

      function updateErrorStyles() {
        var nameOk = nameInput.value.trim().length > 0;
        var classOk = classInput.value.trim().length > 0;
        nameInput.classList.toggle('student-fields__input--error', !nameOk && nameInput.dataset.touched === 'true');
        classInput.classList.toggle('student-fields__input--error', !classOk && classInput.dataset.touched === 'true');
      }

      // Block form submission if fields are empty
      form.addEventListener('submit', function(e) {
        if (!isValid()) {
          e.preventDefault();
          e.stopPropagation();
          nameInput.dataset.touched = 'true';
          classInput.dataset.touched = 'true';
          updateErrorStyles();
          if (nameInput.value.trim().length === 0) {
            nameInput.focus();
          } else {
            classInput.focus();
          }
          return false;
        }
      });

      // Use CSS to visually disable buttons via a parent attribute
      function updateState() {
        updateErrorStyles();
        if (isValid()) {
          container.setAttribute('data-valid', 'true');
        } else {
          container.removeAttribute('data-valid');
        }
      }

      nameInput.addEventListener('input', updateState);
      classInput.addEventListener('input', updateState);
      nameInput.addEventListener('blur', function() { nameInput.dataset.touched = 'true'; updateState(); });
      classInput.addEventListener('blur', function() { classInput.dataset.touched = 'true'; updateState(); });

      // Initial state
      updateState();
    }

    function init() {
      document.querySelectorAll('[id^="StudentFields-"]').forEach(function(el) {
        var sectionId = el.id.replace('StudentFields-', '');
        initStudentFields(sectionId);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
